module.exports = __webpack_public_path__ + "media/images/common/error-4a776f193bf598e4e751f9c5821bf869.png";